import { loginUrl } from "@/api/apiUrl";

const LOGIN_PAGE_URL = loginUrl + '/login'
const TOKEN_EXPIRED_TIME = 86400

class WebAuth {
    constructor(data) {
        console.log(data)
    }

    authorize() {
        // set redirect params
        window.location.replace(`${LOGIN_PAGE_URL}?return_to=${window.location.origin}/callback`);
    }

    parseHash(callback) {
        // check url cred for token access only
        const pageUrl = new URLSearchParams(window.location.search)
        let idToken = null

        if (pageUrl.has('id_token')) {
            idToken = pageUrl.get('id_token')
        }

        if (pageUrl.has('token')) {
            idToken = pageUrl.get('token')
        }

        if (pageUrl.get('accessToken')) {
            idToken = pageUrl.get('accessToken')
        }

        const logoutUrl = pageUrl.get('logout_url') // maybe null value
        const expiresAt = sessionStorage.getItem("expires_at")

        let expiresIn = pageUrl.has('expires') ?
          pageUrl.get('expires') * 1000 : TOKEN_EXPIRED_TIME // 1 day life token

        if ( typeof callback !== 'function' ) return

        if ( expiresAt ) {
            let now = new Date()
            let later = new Date(expiresAt)
            expiresIn = Math.round((later - now) / 1000)
        } else {
            expiresIn = TOKEN_EXPIRED_TIME
        }

        if ( idToken ) {
            callback(false, {
                idToken: idToken,
                expiresIn: expiresIn,
                logoutUrl: logoutUrl
            })
        } else {
            callback({
                errorDescription: 'token/tokens missing!'
            })
        }
    }
}

export default {
    WebAuth: WebAuth,
  };
